import { useCallback } from 'react'
import {
  ObjectEventMessage,
  notifyProjectSettingMemberEvent,
  notifyTenantSettingUserEventMessageEvent,
} from 'features/app/states/appSlice'
import { useAppDispatch } from 'states/hooks'
import { NotifyEventType } from 'enums/app'
import { TenantSettingMember } from '@crew/apis/tenantSetting/models/getTenantSettingMembers/response'
import { useDeleteUserPendingMutation } from '@crew/apis/tenantSetting/tenantSettingApis'
import { InvitationType } from '@crew/enums/app'
import { useDeleteProjectMemberPendingMutation } from '@crew/apis/project/projectApis'
import { ProjectMember } from '@crew/models/domain'

export const useTenantUserTable = () => {
  const dispatch = useAppDispatch()

  // ユーザー保留の削除API
  const [deleteUserPendingMutation, { isLoading: isLoadingDeleteUserPending }] =
    useDeleteUserPendingMutation()

  // プロジェクトメンバー保留の削除API
  const [
    deleteProjectMemberPendingMutation,
    { isLoading: isLoadingDeleteProjectMemberPending },
  ] = useDeleteProjectMemberPendingMutation()

  // Delete pending user process
  const deletePendingUser = useCallback(
    async (tenantMemberPendingId: string, invitationType: InvitationType) => {
      if (invitationType === InvitationType.Tenant) {
        /* テナントユーザーとして招待されたユーザーの場合（ユーザー保留テーブルに登録されているユーザー） */

        // ユーザー保留削除APIを実行
        await deleteUserPendingMutation({
          userPendingId: tenantMemberPendingId,
        }).unwrap()

        // mutation操作の後は、レスポンスを通知する
        const objectEventMessage: ObjectEventMessage<TenantSettingMember> = {
          eventType: NotifyEventType.Deleted,
          id: tenantMemberPendingId,
          object: undefined,
        }
        dispatch(notifyTenantSettingUserEventMessageEvent(objectEventMessage))
      } else if (invitationType === InvitationType.Project) {
        /* プロジェクトメンバーとして招待されたユーザーの場合（プロジェクトメンバー保留テーブルに登録されているユーザー） */

        // プロジェクトメンバー保留削除APIを実行
        await deleteProjectMemberPendingMutation({
          projectMemberPendingId: tenantMemberPendingId,
        }).unwrap()

        // mutation操作の後は、レスポンスを通知する
        const objectEventMessage: ObjectEventMessage<ProjectMember> = {
          eventType: NotifyEventType.Deleted,
          id: tenantMemberPendingId,
          object: undefined,
        }
        dispatch(notifyProjectSettingMemberEvent(objectEventMessage))
      }
    },
    [deleteProjectMemberPendingMutation, deleteUserPendingMutation, dispatch]
  )

  return {
    isLoadingDeleteUserPending,
    isLoadingDeleteProjectMemberPending,
    deletePendingUser,
  }
}
